import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import Loader from "src/components/loader/loader";
import { useAppSelector } from "../../hooks/redux";
const AddToBasketWrapper = () => {
    const addToBasketPayload = useAppSelector((state) => {
        return state.modals.addToBasketPayload;
    });
    const AddToBasket = React.lazy(() => import("src/modals/addToBasket/addToBasket"));
    return (_jsx(_Fragment, { children: addToBasketPayload && (_jsx(React.Suspense, Object.assign({ fallback: _jsx(Loader, {}) }, { children: _jsx(AddToBasket, { payload: addToBasketPayload }) }))) }));
};
export default AddToBasketWrapper;
